import { Box, Divider, Stack, Text } from '@mantine/core'
import React from 'react'
import ReportItem from '../ReportItem'

interface LimitHighConsumptionCaseProps {
  number: number
  item: any
}

export default function LimitHighConsumptionCase({ number, item }: LimitHighConsumptionCaseProps) {
  const cardBackgroundColor = '#ffffff'

  return (
    <Box
      style={{
        backgroundColor: cardBackgroundColor,
        padding: 'var(--mantine-spacing-xs)',
        borderRadius: 'var(--mantine-radius-sm)',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        border: '1px solid rgba(0,0,0,0.05)',
        marginBottom: 'var(--mantine-spacing-xs)',
      }}
    >
      <Stack gap={'xs'} className={'text-gray-500'}>
        <Text size={'sm'} c={'dark'} fw={500}>
          案件（{number}）
        </Text>

        {/* 基本案件信息 */}
        <ReportItem key={'caseCode'} name={'案号'} value={item?.caseCode} />
        <ReportItem key={'courtName'} name={'执行法院'} value={item?.courtName} />
        <ReportItem key={'caseRegTime'} name={'立案时间'} value={item?.caseRegTime} />
        <ReportItem key={'casePublishTime'} name={'发布时间'} value={item?.casePublishTime} />

        {/* 被执行人信息 */}
        <Divider size="xs" color="gray.3" />
        <ReportItem key={'executorName'} name={'限高被执行人姓名'} value={item?.executorName} />
        <ReportItem key={'sexName'} name={'性别'} value={item?.sexName} />
        <ReportItem key={'age'} name={'年龄'} value={item?.age} />
        <ReportItem key={'areaName'} name={'地域名称'} value={item?.areaName} />

        {/* 其他信息 */}
        <Divider size="xs" color="gray.3" />
        <ReportItem key={'dataType'} name={'数据类型'} value={item?.dataType} />
        <ReportItem key={'sign'} name={'下架标识'} value={item?.sign} />
        <ReportItem key={'signalDesc'} name={'信号描述'} value={item?.signalDesc} />
        <ReportItem key={'signalRating'} name={'信号等级'} value={item?.signalRating} />
      </Stack>
    </Box>
  )
}
